import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "ExpressReceiverPanel" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "ExpressReceiverPanel__title" }, "Выберите получателя", -1)
const _hoisted_3 = { class: "ExpressReceiverPanel__scrollable scroll blue" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, "Новый получатель", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("span", null, "Загрузить еще", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_search = _resolveComponent("icon-search")!
  const _component_s_input = _resolveComponent("s-input")!
  const _component_icon_big_plus = _resolveComponent("icon-big-plus")!
  const _component_s_button = _resolveComponent("s-button")!
  const _component_point_in_panel = _resolveComponent("point-in-panel")!
  const _component_panels_loader = _resolveComponent("panels-loader")!
  const _component_receiver_create = _resolveComponent("receiver-create")!
  const _component_s_modal = _resolveComponent("s-modal")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_s_input, {
      class: "ExpressReceiverPanel__search",
      placeholder: "Поиск по номеру телефона, адресу или названию",
      value: _ctx.state.search_query,
      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.search_query = $event)),
      disabled: _ctx.disabled,
      onInput: _ctx.searchReceiverHandler
    }, {
      icon: _withCtx(() => [
        _createVNode(_component_icon_search)
      ]),
      _: 1
    }, 8, ["value", "disabled", "onInput"]),
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_s_button, {
        disabled: _ctx.disabled,
        class: "scrollable__add blue",
        onClick: _ctx.startCreateReceiver
      }, {
        default: _withCtx(() => [
          _createVNode(_component_icon_big_plus),
          _hoisted_4
        ]),
        _: 1
      }, 8, ["disabled", "onClick"]),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.list, (receiver, i) => {
        return (_openBlock(), _createBlock(_component_point_in_panel, {
          key: `ReceiverPointInPanel-${i}`,
          point: receiver,
          blocked: _ctx.disabled,
          selected: _ctx.selectedReceiversIds.includes(receiver.id),
          isEXPRESS: true,
          "is-receiver": "",
          onEdit: _ctx.startEditReceiver,
          onDelete: _ctx.deleteReceiverHandler,
          onSelect: _ctx.emitSelect
        }, null, 8, ["point", "blocked", "selected", "onEdit", "onDelete", "onSelect"]))
      }), 128)),
      (!_ctx.state.is_loading)
        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
            (
                        _ctx.state.pagination.current_page < _ctx.state.pagination.total_pages &&
                        !_ctx.state.is_search
                    )
              ? (_openBlock(), _createBlock(_component_s_button, {
                  key: 0,
                  disabled: _ctx.disabled,
                  class: "scrollable__add blue",
                  onClick: _ctx.loadMore
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"]))
              : _createCommentVNode("", true)
          ], 64))
        : (_openBlock(), _createBlock(_component_panels_loader, { key: 1 }))
    ]),
    (_ctx.isReceiverActionsOpened)
      ? (_openBlock(), _createBlock(_component_s_modal, {
          key: 0,
          onClose: _ctx.closeReceiverActions
        }, {
          body: _withCtx(() => [
            _createVNode(_component_receiver_create, {
              "is-express": "",
              "sender-city-id": _ctx.city.id,
              onCreate: _ctx.createReceiverHandler,
              onUpdate: _ctx.updateReceiverHandler,
              onClose: _ctx.closeReceiverActions
            }, null, 8, ["sender-city-id", "onCreate", "onUpdate", "onClose"])
          ]),
          _: 1
        }, 8, ["onClose"]))
      : _createCommentVNode("", true)
  ]))
}